import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`inline-flex items-center gap-2.5 text-xs sm:text-sm uppercase tracking-[0.22em] font-semibold ${
      light ? "text-emerald-400" : "text-emerald-600"
    } ${className}`}
  >
    <svg viewBox="0 0 22 12" className="h-3 w-5" fill="none" aria-hidden="true">
      <path d="M1 11L11 2l10 9" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <span className={`h-px w-6 ${light ? "bg-emerald-400/60" : "bg-emerald-500/60"}`} />
    {children}
  </span>
);
